module.exports = __webpack_public_path__ + "static/images/styles/images/nations/sweden.f250f998.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/sweden.png
// module id = 3672
// module chunks = 11